export const permissionsDictionary = {
  1: 'Tech',
  2: 'Operações',
  3: 'Atendimento',
  4: 'Antifraude',
  5: 'Geral'
}

export const permissionsFromAD = (businessUnit: string) => {
  const currentBusinessUnit = businessUnit.toLowerCase()

  return {
    [`fidelidade-sso-${currentBusinessUnit}-tech`]: 1,
    [`fidelidade-sso-${currentBusinessUnit}-operacoes`]: 2,
    [`fidelidade-sso-${currentBusinessUnit}-atendimento`]: 3,
    [`fidelidade-sso-${currentBusinessUnit}-antifraude`]: 4,
    [`fidelidade-sso-${currentBusinessUnit}-geral`]: 5
  }
}
